import SearchForm from './SearchForm'
import Router from 'next/router'
import { heavyFormInputs, heavyAdvancedInputs,
    heavyFormInputsMobile, heavyAdvancedInputsMobile } from '@components/search/heavyFormInputs'
import { HEAVY_LINK_BASE } from '@constants/searchFormLinks'
import paliwo from '@components/search/inputs/paliwo'

import searchFormLink from '@utils/links/searchFormLink'

const HeavyForm = ({ overrideDefaultValues }) => {
    const navigateToSearchPage = (data) => {
        const link = searchFormLink({
            data,
            linkBase: HEAVY_LINK_BASE,
            isMakeModelBase: true
        })

        Router.push(link)
    }

    return <SearchForm
        inputs={heavyFormInputs}
        mobileInputs={heavyFormInputsMobile}
        dataKey="ciezarowe"
        overrideDefaultValues={overrideDefaultValues}
        onSubmit={navigateToSearchPage}
        actionBar={{
            paliwo,
            clear: true,
            advancedOptions: heavyAdvancedInputs,
            advancedOptionsMobile: heavyAdvancedInputsMobile,
        }} />
}

export default HeavyForm